<template>
    <div class="card-viewer-app"> 
      <!-- <explainer /> -->
      <transition name="fade">
         <div v-if="!lessonLoaded" class="card-container loader"   > 
              <fullscreen-loader />
         </div>
      </transition>
      <transition name="fade">
          <card-viewer v-if="lessonLoaded && (lessonType=='cards' || segmentSet)" ref="cardViewer" />    
          <video-viewer v-else-if="lessonLoaded && lessonType=='video'" />
          <div class="card" v-else-if="lessonLoaded">
            <div class="card-body">
              <i>Failed to load lesson.</i>
            </div>
        </div>
      </transition>      
    </div>
  </template>
  
  <script lang="ts">
  import { Options, Inject, Provide, Vue } from 'vue-property-decorator';
  import CardViewer from '@/components/cards/CardViewer.vue'
  import VideoViewer from '@/components/cards/VideoViewer.vue'  
  import { LessonController, LessonOptions } from '@/controllers/LessonController';
  import { CourseRepository, LessonDetail } from '@/data/repository/CourseRepository';
  import { ProgressRepository } from '@/data/repository/ProgressRepository';
  import { Router } from '@/Router';
  import { WordlistRepository } from '@/data/repository/WordlistRepository';
  import Explainer from '@/components/shell/Explainer.vue';
  import { EntryRepository } from '@/data/repository/EntryRepository'; 
  import { DictionaryRepository } from '@/data/repository/DictionaryRepository';
import { EmurseContext } from "@/EmurseContext";
  
import FullscreenLoader from '@/components/core/FullscreenLoader.vue'
import { LanguageFeatureTypes } from '@/languages/LanguageFeatureTypes';
   
  @Options({
    components: {
      CardViewer,
      VideoViewer,
      Explainer,
      FullscreenLoader
    } 
  })
  export default class CardViewerApp extends Vue
  {
    
    @Inject() public courseRepository!: CourseRepository;
    @Inject() public progressRepository!: ProgressRepository;
    @Inject() public wordlistRepository!: WordlistRepository;
    @Inject() public entryRepository!: EntryRepository;
    @Inject() public dictionaryRepository!: DictionaryRepository; 
    @Inject() public languageFeatureTypes!: LanguageFeatureTypes;

    @Provide("emurseContext") private emurseContext: EmurseContext = new EmurseContext("lesson",true);
    @Provide("lessonController") public lessonController!: LessonController;
  
    public lessonLoaded = false;
    public lessonError = false;
    public lessonType = "";
    public segmentSet = false;

    public created()
    {
      this.lessonController = new LessonController();
      
      this.lessonController.injectRepositories(this.courseRepository,
                                            this.progressRepository,
                                            this.wordlistRepository,
                                            this.entryRepository,
                                            this.dictionaryRepository,
                                            this.emurseContext);

      //TODO: consider moving this up to startup.                                             
      this.emurseContext.entryRepository = this.entryRepository;
      this.emurseContext.wordlistRepository = this.wordlistRepository;
      this.emurseContext.languageFeatureTypes = this.languageFeatureTypes;
      this.emurseContext.courseRepository= this.courseRepository;


    //assume the last part of the URL is the lesson id.
    
    const r = new Router([{url: '/course/:courseUid/quickstudy/:listId/:studyType' }, 
                          {url: '/course/:courseUid/drill/:drillId/list/:listId'},
                          {url: '/lesson/:uid/segment/:segmentId' },
                          {url: '/lesson/:uid' },
                          {url: '/course/:courseUid/review' }, 
                          {url: '/course/:courseUid/lesson/:uid' },
                          {url: '/course/:courseUid/lesson/:uid/segment/:segmentId' },                        
                          {url: '/course/:courseUid/lesson/:uid/drill/:drillId' },         
                          {url: '/course/:courseUid/lesson/:uid/quickstudy/:studyType' },  
                          {url: '/course/:courseUid/lesson/:uid/preview' },
                          {url: '/course/:courseUid/lesson/:uid/practice' },
                        ]);
    const routePath = document.location.pathname;
    const route= r.getParams(routePath); 
   
    if (route.params.uid || route.params.listId || route.params.courseUid) {
      
      const options = new LessonOptions(route.params.uid  );
  
      for(const i in options)
      {
        if (route.params[i])
        {
          (options as any)[i] = route.params[i];
        }
      }

      if ( routePath.indexOf("/course/demo/")>=0  ||
          (route.params.uid && route.params.courseUid && routePath.endsWith("/preview"))
         )
      {
        options.isDemo = true;
      }
       

      if (routePath.endsWith("/practice"))
      {
        options.mode="practice";
      }    
      else if (routePath.endsWith("/review"))
      {
        options.mode="review";
      }
      else if (routePath.indexOf('/quickstudy/')>0)
      {
        options.mode="quickstudy";
      }
      else if (routePath.indexOf('/drill')>0)
      {
        if (options.listId)
        {
          options.mode="wordlist-drill";
        }
        else if(options.uid)
        {
          options.mode="lesson-drill";
        }
        options.useConfigTransform=document.location.href.indexOf("userconfig=true")>0;
      }
 

      //add injections
      this.emurseContext.courseUid = route.params.courseUid;
      options.emurseContext=this.emurseContext;

      //load enrollment settings
      if (this.emurseContext.courseUid) {
        this.emurseContext.loadCourseEnrollmentSettings();
      }
 
      try
      {
        let queryParams= Object.fromEntries(new URLSearchParams(window.location.search));
        if (queryParams.preview=='true') {
          options.isSegmentPreview=true;
        }
      }
      catch {
        console.log("Failed to parse lesson options.")
      }

      this.lessonController.loadLesson(options).then((detail: LessonDetail)=> {

        if ( /\/segment\//.test(routePath) ) {
          let name=detail?.lesson?.segments[0]?.name;
          document.title = `Emurse - ${name}`;
          this.segmentSet = true;
        }

        this.lessonType = detail?.lesson?.type ?? "cards";
         
        //this.emurseContext.languageFeatures.language = (detail.lesson as any).language;
        this.lessonLoaded=true;      
      }).catch((error)=>{ 
          this.lessonError=true;
          this.lessonLoaded=true;
        
      })
    }
  }
  
  }
  </script>
  
  <style lang="scss" scoped>
  body {margin:0px;padding:0px;}
  .card-viewer-app {
    text-align: center;
    
    .card-item {
      color: #2c3e50;
    }
  }
  </style>
 